import { render } from "./write-to-target-tips.vue?vue&type=template&id=4c563caf"
import script from "./write-to-target-tips.vue?vue&type=script&lang=js"
export * from "./write-to-target-tips.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__